(() => {
  if (window.japotyleCategoryMenuInitialized) return;
  window.japotyleCategoryMenuInitialized = true;

  const itemSelector = '.japotyle-category-menu__item';

  const closeOpenMenus = () => {
    document.querySelectorAll(`${itemSelector}[open]`).forEach((item) => {
      item.removeAttribute('open');
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target || !target.closest(itemSelector)) closeOpenMenus();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const focusedItem = document.activeElement?.closest?.(itemSelector);
    const hasOpenMenu = document.querySelector(`${itemSelector}[open]`);
    if (!hasOpenMenu) return;

    closeOpenMenus();
    focusedItem?.querySelector('summary')?.focus();
  });
})();
